import { Editor } from "react-draft-wysiwyg";
import draftToHtml from "draftjs-to-html";
import {
  EditorState,
  convertFromRaw,
  convertToRaw,
  convertFromHTML,
  ContentState,
  Modifier,
  SelectionState,
} from "draft-js";
import React, { useContext, useState, useEffect } from "react";

function Editorjs({ editorTemp, setEditorTemp }) {
  const [firstTime, setFirstTime] = useState(true);
  const updateTextDescriptionData = (state, name) => {
    if (!state || typeof state.getCurrentContent !== "function") return;

    const blocks = draftToHtml(convertToRaw(state.getCurrentContent()));
    setEditorStateData({ ...editorStateData, [name]: state });
    setEditorTemp(blocks);
  };

  function applyAlignmentToBlocks(contentState, alignments = {}) {
    let newContentState = contentState;
    const blockMap = contentState.getBlockMap();
    blockMap.forEach((block, blockKey) => {
      // Esempio: centra il primo blocco, destra gli ultimi due
      if (alignments[blockKey]) {
        const selection = SelectionState.createEmpty(blockKey);
        newContentState = Modifier.setBlockData(newContentState, selection, {
          "text-align": alignments[blockKey],
        });
      }
    });
    return newContentState;
  }

  const [editorStateData, setEditorStateData] = useState({
    nome: EditorState.createEmpty(),
    descrizione: EditorState.createEmpty(),
    costo: EditorState.createEmpty(),
    needeed: EditorState.createEmpty(),
  });

  useEffect(() => {
    if (editorTemp && firstTime) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(editorTemp, "text/html");
      const htmlBlocks = Array.from(doc.body.children);
      const blocksFromHTML = convertFromHTML(editorTemp);
      let contentState = ContentState.createFromBlockArray(
        blocksFromHTML.contentBlocks,
        blocksFromHTML.entityMap
      );
      const blockKeys = contentState.getBlockMap().keySeq().toArray();

      const alignments = {};
      htmlBlocks.forEach((el, i) => {
        const style = el.getAttribute("style");
        if (style && style.includes("text-align")) {
          const match = style.match(/text-align\s*:\s*(\w+)/);
          if (match && match[1]) {
            alignments[blockKeys[i]] = match[1];
          }
        }
      });

      contentState = applyAlignmentToBlocks(contentState, alignments);

      setEditorStateData((prev) => ({
        ...prev,
        descrizione: EditorState.createWithContent(contentState),
      }));
    }
    setFirstTime(false);
  }, [editorTemp]);

  return (
    <Editor
      editorState={editorStateData.descrizione}
      toolbarClassName="toolbarClassName"
      editorClassName="editorClassName"
      editorStyle={{
        border: "20px solid #ccc",
        minHeight: 200,
        height: "auto",
      }}
      onEditorStateChange={(e) => updateTextDescriptionData(e, "descrizione")}
    ></Editor>
  );
}

export default Editorjs;
